import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import App from './App';
import rootReducer from './modules/reducer';
import sagas from './modules/sagas';

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];
const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
  blacklist: ['indexGrab', 'error'],
};
const pReducer = persistReducer(persistConfig, rootReducer);
// create a redux store with our reducer above and middleware
const store = createStore(
  pReducer,
  composeWithDevTools(...[applyMiddleware(...middlewares)]),
);
const persistor = persistStore(store);
persistor.purge(); // Purge the local storage at startup

// run the saga
sagaMiddleware.run(sagas);
type PropsType = {};
export default class Store extends Component<PropsType> {
  props: PropsType;

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App store={store} />
        </PersistGate>
      </Provider>
    );
  }
}